import React from 'react'
import UpdateUser from '../Components/UpdateUser'

function UpdateAcc() {
  return (
    <div>
      <UpdateUser/>
    </div>
  )
}

export default UpdateAcc